<p>
  login works!
</p>

<button (click)="oauth2SignIn();">Try sample request</button>
 